export default __webpack_public_path__ + "a38d1a1332c38112c65adc48b37c6f96.svg";